<template>
  <ul>

      <li class="bg-blue-400 text-pink-700 rounded p-1"
      v-for= "locale in locales" :key="locale" @click="switchLocal(locale)">{{locale}} </li>
  </ul>
</template>

<script>
export default {

    name:'localeSwitcher',

    methods: {

        switchLocal(locale){

            if(this.$i18n.locale != locale){

                this.$i18n.locale = locale;
            }
        }
    },

    data: function(){

        return{

            locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')
        }
    }
}
</script>

<style>

</style>